define('components/handlers/filters',[
    'jquery',
    'components/decorator',
    '../util/tool-menu',
    '../util/reload-fragments',
], function($, decorator, toolMenu, reload) {
    var MAX_RESULT_COUNT = 3000;

    toolMenu = toolMenu.create({
        persist: true,
        className: "guide-tool-menu",
        hideCloseButton: true,
        position: "left",
        autoClose: 3000,
        clearContent: true
    });

    $.extend(companyInfo.handlers, {

        'filters-admin': function() {
            var filtersAdmin = $('.filters-admin');

            filtersAdmin.toggleClass('show');
        },
        'filters-mobile': function() {
            var filters = $('#filters');

            filters.toggleClass('show');
        },
        'filters-download': function(e) {
            e.preventDefault();

            if(this.hasAttribute("data-confirm")) {
                var confirmText = this.getAttribute("data-confirm");
                if(!confirm(confirmText)) {
                    return;
                }
            }

            var form = $('#main-form');
            var $elm = $(e.target).parent();
            form.data('add-param', 'export=true');
            form.data('refresh', 'true');

            //when there are more than 3000 results, show a notification that the excel sheet
            //will only export the top 3000 results
            if($("[data-search-result-count]").length>0){
              var resultCount = $("[data-search-result-count]").data("search-result-count");
              var maxExport = $("[data-search-max-export]").data("search-max-export");
              var messageText = $elm.find("[data-message-maxupload]");
              if(messageText.length>0 && resultCount > maxExport){
                toolMenu.show(messageText.html(), e.target);
              }
              $(this).attr('disabled', 'disabled');

            }

            //show a loader instead of the download icon (if available)
            //and show it as long as the toolMenu is showing
            showSpinnerIcon($elm);

            form.submit();

            form.addClass("download");
        },
        'filters-clear': function() {
            var component = $(this);
            if (!component.hasClass('disabled')) {
                var form = $('#main-form');
                var filters = $('#filters');
                var reloadType = form.data('reload-type');
                var params = form.serializeArray();
                var newParams = [];
                var filterNames = [];
                filters.find('[name]').each(function() {
                    filterNames.push($(this).attr('name'));
                });
                params.forEach(function(param) {
                  if ($.inArray(param.name, filterNames) === -1 && param.name !== 'page') {
                        if (param.name !== "query") {
                            param = param.name + "=" + param.value;
                            newParams.push(param);
                        }
                    }
                });

                var url = [location.pathname,newParams.join('&')].join('?');
                reload( reloadType, url, function(){
                    PubSub.publish('RELOAD_FILTERS');
                });
            }
        }

    });

    /**
     * replaces the icon of the link with a spinner.
     * @param  {html} elm the object link
     */
    function showSpinnerIcon(elm){
      if(elm){
        var icon = elm.find("i.ico");
        if(icon){
          var classes = icon.attr("class");
          icon.attr("class", "ico ico-spinner ico-spin icon-single");

          setTimeout(function(){
            icon.attr("class", classes);
          }, toolMenu.getSetting("autoClose"));
        }
      }
    }

});

